import qs from 'qs'
import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { certificateApiReq, certificateApiRes } from './interface'

class CertificateApi implements apiInterface.ICertificateApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  getCertificates = async (
    params: certificateApiReq.IGetCertificateReq = {}
  ): Promise<certificateApiRes.IGetCertificateRes> => {
    const res = await this.ctx.get<
      certificateApiReq.IGetCertificateReq,
      certificateApiRes.IGetCertificateRes
    >('/certificate', { ...params })
    return res.data
  }

  activateCertificate = async (
    params: certificateApiReq.IActivateCertificateReq
  ): Promise<certificateApiRes.IActivateCertificateRes> => {
    const res = await this.ctx.post<
      certificateApiReq.IActivateCertificateReq,
      certificateApiRes.IActivateCertificateRes
    >('/certificate/activation/', params)
    return res.data
  }

  extendCertificates = async (data: certificateApiReq.IExtendCertificatesReq) => {
    const res = await this.ctx.post<
      certificateApiReq.IExtendCertificatesReq,
      certificateApiRes.IExtendCertificatesRes
    >('/certificate/bulk_expiration_extend/', data)
    return res.data
  }

  getCertificatesGenerator = async (
    params: certificateApiReq.IGetCertificateGeneratorReq = {}
  ): Promise<certificateApiRes.IGetCertificateGeneratorRes> => {
    const res = await this.ctx.get<
      certificateApiReq.IGetCertificateGeneratorReq,
      certificateApiRes.IGetCertificateGeneratorRes
    >('/certificate/generator/', params)
    return res.data
  }

  getCertificatesGeneratorById = async (
    id: number
  ): Promise<certificateApiRes.IGetCertificateGeneratorByIdRes> => {
    const res = await this.ctx.get<unknown, certificateApiRes.IGetCertificateGeneratorByIdRes>(
      `/certificate/generator/${id}/`
    )
    return res.data
  }

  getUnActivatedCertificate = async (params: certificateApiReq.IGetUnActivatedCertificateReq) => {
    const res = await this.ctx.get<
      certificateApiReq.IGetUnActivatedCertificateReq,
      certificateApiRes.IGetUnActivatedCertificateRes[]
    >('/certificate/number_series_staff/', params, {
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
    })
    return res.data
  }

  printCertificates = async (
    params: certificateApiReq.IPrintCertificatesReq[]
  ): Promise<certificateApiRes.IPrintCertificatesRes[]> => {
    const res = await this.ctx.post<
      certificateApiReq.IPrintCertificatesReq[],
      certificateApiRes.IPrintCertificatesRes[]
    >('/certificate/qr_actions/', params)
    return res.data
  }
}

export default CertificateApi
